// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"10":"d8f85a15","860":"83611e9f"}[chunkId] + ".js";
};